import yup from 'src/libs/yup';

const BenefitFilterSchema = yup.object().shape({
  name: yup.string().label('Nome'),
  description: yup.string().label('Descrição'),
  slug: yup.string().label('URL'),
  type: yup.string().nullable().label('Tipo'),
  status: yup.string().nullable().label('Status'),
});

export default BenefitFilterSchema;
